<!-- floating-menu.component.html with click outside directive -->
<div
  #toolboxContainer
  class="floating-menu-container"
  [ngClass]="{
    dragging: isDragging,
    green: colorTheme === 'green',
    purple: colorTheme === 'purple',
    elegant: colorTheme === 'elegant',
    modern: colorTheme === 'modern',
    'menu-open': isMenuOpen
  }"
  cdkDrag
  [cdkDragFreeDragPosition]="position"
  (cdkDragStarted)="onDragStart()"
  (cdkDragEnded)="onDragEnd($event)"
  cdkDragHandle
  [cdkDragConstrainPosition]="constrainPosition"
  >
  <!-- Menu Trigger Button -->
  <button
    class="menu-trigger"
    (click)="!isDragging && toggleMenu(); $event.stopPropagation()"
    [disabled]="isDragging"
    >
    <mat-icon>menu</mat-icon>
  </button>
  <!-- Floating Menu Panel -->
  <div
    class="floating-menu"
    [class.open]="isMenuOpen && !isDragging"
    (click)="onMenuClick($event)"
    clickOutside
    (clickOutside)="closeMenu()"
    >
    <div class="menu-header">
      <div class="profile-section">
        <div class="profile-image">
          <img
            class="profile_img"
            [src]="profileImg || '/assets/images/defualt-profile.jpg'"
            alt="profile-img"
            routerLink="/buyer/account/profile"
            />
          </div>
          <div class="profile-info">
            <div class="user-name">{{ userName || "Guest User" }}</div>
            <div
              class="log-out"
              (click)="handleSignOut()"
              data-translation-key="buyer_header_log_out"
              >
              {{ "buyer_header.log_out" | translate }}
            </div>
          </div>
        </div>
        <div class="gold-accent"></div>
      </div>

      <ul class="menu-items">
        @for (item of menuItems; track item) {
          @if (!item?.subMenu) {
            <li
              class="menu-item"
              [class.active]="item.route == router.url"
              (click)="selectItem(item)"
              [routerLink]="item.route"
              >
              <div class="menu-item-text">{{ item.label }}</div>
              <div class="menu-item-arrow">
                <mat-icon>chevron_right</mat-icon>
              </div>
              @if (item.notifications && item.notifications > 0) {
                <div
                  class="notification-badge"
                  >
                  {{ item.notifications }}
                </div>
              }
            </li>
          }
          @if (item?.subMenu) {
            <li
              class="menu-item"
              [class.active]="item.subMenu.includes(router.url)"
              >
              <app-dropdown
                class="w-100"
                [title]="'buyer_header.my_offers' | translate"
                data-translation-key="buyer_header_my_offers"
                [items]="item.subMenu"
                [size]="'small'"
                [colorTheme]="'dark'"
                >
              </app-dropdown>
            </li>
          }
        }
      </ul>

      <!-- <div class="menu-footer">
      <div class="profile-section">
        <div class="profile-image">
          <img
            class="profile_img"
            [src]="profileImg || '/assets/images/defualt-profile.jpg'"
            alt="profile-img"
            routerLink="/buyer/profile"
            />
          </div>
          <div class="profile-info">
            <div class="user-name">{{ userName || "Guest User" }}</div>
            <div class="log-out" (click)="handleSignOut()">
              {{ 'buyer_header.log_out' | translate }}
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
